import * as React from 'react';

import ErrorState404140 from './ErrorState404140';

export const errorState404140 = () => <ErrorState404140 />;

export default {
    title: 'Illustration|ErrorState404140',
    component: ErrorState404140,
    parameters: {
        notes: "`import ErrorState404140 from 'box-ui-elements/es/illustration/ErrorState404140';`",
    },
};
